import { twMerge } from 'tailwind-merge';
import { useForm, useFormVersion } from '@witmetrics/data-store';
import type { PendingSubmission } from '@/providers/NewCaseProvider';
import Card from '@/components/Card';
import StepStatus from '../StepStatus';
import type { CreationStepStatus } from '../../types';
import { CREATION_STEP_STATUS } from '../../constants';
import { classes } from '../utils';

const { PENDING } = CREATION_STEP_STATUS;

export type SubmissionRowProps = {
  submission: PendingSubmission;
  status: CreationStepStatus;
  onRetry: () => void;
};

export default function SubmissionRow({
  submission,
  status,
  onRetry,
}: SubmissionRowProps) {
  const formVersion = useFormVersion(submission.versionId);
  const form = useForm(formVersion?.formId);

  return (
    <Card
      className={twMerge(classes.card, status === PENDING && classes.pending)}>
      <StepStatus status={status} onRetry={onRetry} />
      {form?.name || 'Form'}
    </Card>
  );
}
